:host {
  display: block;
  height: auto;

  .hide {
    display: none !important;
  }

  .flex {
    display: flex;
  }

  .loader {
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .contact {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .contact-list-mail {
    &.loaderMail {
      justify-content: center;
    }
  }

  .contact-list-support-premium {
    &.list-item {
      img {
        width: 32px;
        height: 32px;
      }
      .list-item-status {
        img {
          width: 14px;
          height: 14px;
        }
      }
      .list-item-text__description {
        width: 70%;
      }
    }
    &:hover {
      background: var(--bg-hover);
    }
  }

  .contact-list-chat {
    .flex {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      margin-right: 20px;
      box-sizing: border-box;
    }

    &__left {
      display: flex;
    }

    &__right {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 10px;
      border-radius: 6px;
      background-color: #f5f5f5;
      background-color: var(--bg-secondary);
      font-size: 12px;
      letter-spacing: 0;
      line-height: 16px;
      color: #666666;
      color: var(--font-secondary);
      margin-left: 20px;

      span {
        color: #333333;
        color: var(--font-primary);
      }
    }
  }

  .contact-list {
    padding-right: 15px;
    box-sizing: border-box;
    max-width: 90%;

    .contact-list-phone {
      .flex {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        margin-right: 20px;
        box-sizing: border-box;
        &.no-width {
          width: unset;
        }
      }

      &__left {
        display: flex;
      }

      &__right {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 10px;
        border-radius: 6px;
        background-color: #f5f5f5;
        background-color: var(--bg-block);
        font-size: 12px;
        letter-spacing: 0;
        line-height: 16px;
        color: #666666;
        color: var(--font-secondary);
        margin-left: 20px;

        span {
          color: #333333;
          color: var(--font-primary);
        }
      }
    }

    &.blur {
      filter: blur(3px);
    }
  }

  .list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 85px;
    background-color: #ffffff;
    background-color: var(--bg-primary);
    border-radius: 6px;
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 10px;
    cursor: pointer;

    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
      margin-right: 10px;
      display: block;
    }
    .list-item-text {
      &__title {
        color: #333333;
        color: var(--font-primary);
        font-size: 15px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 21px;
      }

      &__description {
        color: #979ba4;
        color: var(--font-tertiary);
        font-size: 14px;
        letter-spacing: 0;
        line-height: 16px;
      }

      &__opening-time {
        display: flex;
        gap: 16px;
        div {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          color: var(--font-secondary);
          img {
            width: 12px;
            height: 12px;
            margin-right: 0;
          }
        }
      }
    }

    .list-item-status-wrapper {
      display: flex;
      gap: 8px;
      .only-vip-access {
        font-size: 14px;
        font-weight: 400;
        color: #ff8500;
      }
    }

    .list-item-status {
      display: flex;
      align-items: center;

      span {
        height: 10px;
        width: 10px;
        background-color: #3ebf4d;
        background-color: var(--green);
        display: block;
        border-radius: 50%;

        &.disabled {
          background-color: #e91e63;
          background-color: var(--red);
          &.only-vip-access {
            background-color: #ff8500;
          }
        }
      }
    }

    &.disabled {
      background-color: #f1f1f1;
      cursor: not-allowed;
    }
  }

  .contact-list-busy {
    img {
      filter: invert(54%) sepia(36%) saturate(3926%) hue-rotate(2deg) brightness(104%)
        contrast(107%);
      filter: var(--icon-orange);
    }
  }
  /* -------------------------------------------------------------------------- */
  /*                                 RESPONSIVE                                 */
  /* -------------------------------------------------------------------------- */

  // Medium devices (tablets, 768px and up)
  @media (max-width: 768px) {
    .contact-list {
      max-width: 100%;

      .contact-list-chat {
        &__right {
          text-align: center;
        }
      }

      .contact-list-phone {
        &__right {
          text-align: center;
        }
      }
    }
  }
}
